import { render, staticRenderFns } from "./WhatsappBroadcastFailed.vue?vue&type=template&id=010151e1&scoped=true"
import script from "./WhatsappBroadcastFailed.vue?vue&type=script&lang=js"
export * from "./WhatsappBroadcastFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010151e1",
  null
  
)

export default component.exports